// extracted by mini-css-extract-plugin
export default {"body":"Body_body__F+EcN","primary":"Body_primary__mVE40","secondary":"Body_secondary__TqqVN"};